<template>
  <div class="shareOut">
    <div class="weixin-tip" v-if="maskShow" @click="closeMaskShow()">
      <p>
        <img
          v-if="!isIOS"
          src="./../../../assets/common/live_weixin.png"
          alt="微信打开"
        />
        <img
          v-if="isIOS"
          src="./../../../assets/common/live_weixin_ios.png"
          alt="微信打开"
        />
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    maskShow: {
      required: true,
    },
  },
  data() {
    return {
      isIOS: false,
    };
  },
  mounted() {
    var u = navigator.userAgent;
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  methods: {
    closeMaskShow(){
      this.$emit("closeMaskShow");
    }
  },
};
</script>
<style lang="less" scoped>
.weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  p {
    padding: 15px 25px;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
